import http from '@/utils/http'
import qs from 'qs'

//设置企业是否在企业馆二维码显示
export const setcompanyshowincomqrcode = (params) =>{
    return http.postform('/usersetting/setcompanyshowincomqrcode',qs.stringify(params))
}
